import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import auth from 'helpers/auth';
import { connect } from 'react-redux';
import PageContainer from '../../layout/PageContainer';
import { API, BASE_URL, } from '../../../CONST';
import DownloadBtn from '../../shared/DownloadBtn';
import BaseTable from '../../shared/BaseTable';
import { cellNumOperation, cellOperation, headerOperation } from '../../../helpers/tables';

const GarantiaPolicyDetail = ({user}) => {
  const [ linea, setLinea ] = useState(null);
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    const url = `${BASE_URL}${API.fullLineaGarantia}/propia/`;
    setLoading(true);
    auth.fetch(url).then(setLinea).finally(() => setLoading(false));
  }, []);

  const movimientos = linea ? linea.movimientolineagarantia_set : [];

  const xlsxUrl = linea
    ? `${BASE_URL}${API.fullLineaGarantia}/${linea.id}/xlsx/`
    : '';

  const pdfUrl = linea
    ? `${BASE_URL}${API.fullLineaGarantia}/${linea.id}/pdf/`
    : '';
  
  const columns = [
      {
        Header: headerOperation('#'),
        id: 'secuencia',
        accessor: mov => cellOperation(mov.num),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Fecha Movimiento'),
        id: 'fecha',
        accessor: mov => cellOperation(mov.fecha),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Tipo'),
        id: 'tipo',
        accessor: mov => cellOperation(mov.caption_tipo),
        sortable: false,
        minWidth: 100,
      },
      {
        Header: headerOperation('Línea a la Fecha Indicada (UF)'),
        id: 'balance__linea',
        accessor: mov => cellNumOperation(mov.balance.linea),
        sortable: false,
        minWidth: 150,
      },
      {
        Header: headerOperation('Cúmulo a la Fecha Indicada (UF)'),
        id: 'balance__cumulo',
        accessor: mov => cellNumOperation(mov.balance.cumulo),
        minWidth: 140,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Estado'),
        id: 'estado',
        accessor: mov => cellOperation(mov.estado),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
      {
        Header: headerOperation('Observación', 'left'),
        id: 'justificacion',
        accessor: mov => cellOperation(mov.justificacion),
        minWidth: 100,
        filterable: false,
        sortable: false,
      },
    ];

  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        {id: 3, name: 'DETALLE LÍNEA CARTERA CLIENTES' },
      ]}
    >
      <>
        <div style={{ display: 'grid', gridTemplateColumns: '500px 700px', alignItems: 'center' }}>
          <div
            style={{
              display: 'grid', gridTemplateColumns: '65px auto', gridGap: '4px 15px',
              padding: '0 0 16px 16px'
            }}
          >
            <div className="orsan-label">Nombre:</div>
            <div className="orsan-value">{user.organization_name}</div>
            <div className="orsan-label">RUT:</div>
            <div className="orsan-value">{user.organization_rut}</div>
          </div>
          <div>
            <table className='table table-striped' style={{border: '1px solid #CCCCCC' }}>
              <thead>
                <tr className='text-center table-header'>
                  <th scope='col'>Línea Vigente (UF)</th>
                  <th scope='col'>Cúmulo Vigente (UF)</th>
                  <th scope='col'>Cupo Restante (UF)</th>
                </tr>
              </thead>
              <tbody>
                <tr className='text-center table-cell'>
                  <td>{linea ? cellNumOperation(linea.balance.linea) : '-'}</td>
                  <td>{linea ? cellNumOperation(linea.balance.cumulo) : '-'}</td>
                  <td>{linea ? cellNumOperation(linea.balance.cupo_restante) : '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto max-content max-content',
            gridGap: '10px',
            marginTop: '15px',
            marginBottom: '6px',
          }}
        >
          <div />
          <div>
            <DownloadBtn
              id='xlsx-download'
              text='XLSX'
              tipText='Descargar Planilla Excel'
              url={xlsxUrl}
            />
          </div>
          <div>
            <DownloadBtn
              id='pdf-download'
              text='PDF'
              tipText='Descargar PDF'
              url={pdfUrl}
            />
          </div>
        </div>
        <BaseTable
          columns={columns}
          data={movimientos}
          loading={loading}
          style={{ maxHeight: '63vh' }}
          showBorders
        />
      </>
    </PageContainer>
  );
};

GarantiaPolicyDetail.propTypes = {
  user: PropTypes.shape({
    organization_name: PropTypes.string,
    organization_rut: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  user: state.login.user,
});

export default connect(mapStateToProps)(GarantiaPolicyDetail);
